var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 791.454 791.454",
    height: 512,
    viewBox: "0 0 791.454 791.454",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_9_",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m202.8 0h264.71l224.217 233.922v454.459c0 56.891-46.182 103.073-103.073 103.073h-385.854c-56.891 0-103.073-46.182-103.073-103.073v-585.308c0-56.891 46.182-103.073 103.073-103.073z",
    fill: "#0ac963"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m467.176 0v231.914h224.552z",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.29 395.56h-201.126c-15.059 0-27.442 12.382-27.442 27.442v127.837c0 15.059 12.382 27.442 27.442 27.442h201.126c15.059 0 27.107-12.382 27.107-27.442v-127.838c0-15.059-12.047-27.441-27.107-27.441zm-146.243 34.469c16.398 0 29.449 13.386 29.449 29.449 0 16.398-13.051 29.784-29.449 29.784s-29.784-13.386-29.784-29.784c0-16.063 13.386-29.449 29.784-29.449zm155.279 120.81c0 5.02-4.016 9.37-9.036 9.37h-201.126c-5.02 0-9.036-4.35-9.036-9.37v-5.354l36.477-36.477 30.119 30.119c3.681 3.681 9.37 3.681 13.051 0l75.632-75.632 63.919 63.919z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.ef3100aaf3127cb5b3b38e9629a3d8cf.svg";
export { ForwardRef as ReactComponent };